import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { income } from '@/react-query/queries/ic-report/hooks'

const colDefs = createColDefs([
  { field: 'new_value', headerName: 'New Value' },
  { field: 'old_value', headerName: 'Old Value' },
])

export interface RatingChangeTableProps extends ICReportTablePrimitive {}

export const RatingChangeTable: React.FC<RatingChangeTableProps> = ({ params, options }) => {
  const query = income.useRatingChange(params)
  const data = query.data

  return (
    <CustomAgGrid
      rowData={data}
      columnDefs={colDefs}
      statusBar={{ statusPanels: [] }}
      {...options}
    />
  )
}
